import Address from "../../../containers/Profile/Documentation/Address/AddressContainer";
import BankData from "../../../containers/Profile/Documentation/BankData/BankDataContainer";
import Identity from "../../../containers/Profile/Documentation/Identity/IdentityContainer";
import Previred from "../../../containers/Profile/Documentation/Previred/PreviredContainer";
import References from "../../../containers/Profile/Documentation/References/ReferencesContainer";
import Salary from "../../../containers/Profile/Documentation/Salary/SalaryContainer";
import Documentation from "../../../containers/Profile/Documentation/EntryPointContainer";
import { RouteObject } from "../../../interfaces/navigation";

export const documentationSubRoutes: RouteObject[] = [
    {
        title: "Dirección",
        path: "direccion",
        component: <Address/>
    },
    {
        title: "Datos Bancarios",
        path: "datos_bancarios",
        component: <BankData/>
    },
    {
        title: "Identificación",
        path: "identificacion",
        component: <Identity/>
    },
    {
        title: "Certificado Previred",
        path: "certificado",
        component: <Previred/>
    },
    {
        title: "Referencias",
        path: "referencias",
        component: <References/>
    },
    {
        title: "Salario",
        path: "salario",
        component: <Salary/>
    }
];

export const documentationRoutes: RouteObject[] = [
    {
        title: "Documentos",
        path: "documentacion",
        component: <Documentation/>,
        subRoutes: documentationSubRoutes
    }
];